import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { RoutesPaths } from "../../constants/user-routes"
import Images from "../../Images"

import "./styles.less"

function NotFoundPage(props) {
  const { auth } = props

  return (
    <div className="not-found">
      <img src={Images.logo} alt="" />
      <div className="not-found-content">
        <div>404</div>
        <p>Unfortunately, this page doesn’t exist.</p>
        <p>
          Try{" "}
          <Link
            to={
              !!auth?.accessToken && auth?.userInfo?.new_onboarding_finished && !auth?.isAdmin
                ? RoutesPaths.dashboard.root
                : "/login"
            }
          >
            start from the mainpage
          </Link>
        </p>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps)(NotFoundPage)
